(function () {
   if (customElements.get('category-story-menu')) return;

   var debounce = function (fn, wait) {
      var t;
      return function () {
         clearTimeout(t);
         t = setTimeout(fn, wait);
      };
   };

   customElements.define('category-story-menu', class extends HTMLElement {
      connectedCallback() {
         this._viewport = this.querySelector('.csm-viewport');
         this._leftBtn = this.querySelector('.csm-arrow--left');
         this._rightBtn = this.querySelector('.csm-arrow--right');

         if (!this._viewport) return;

         var self = this;
         var step = function () {
            return Math.max(120, self._viewport.clientWidth - 80);
         };

         if (this._leftBtn) {
            this._leftBtn.addEventListener('click', function () {
               self._viewport.scrollBy({ left: -step(), behavior: 'smooth' });
            });
         }

         if (this._rightBtn) {
            this._rightBtn.addEventListener('click', function () {
               self._viewport.scrollBy({ left: step(), behavior: 'smooth' });
            });
         }

         var updateArrows = function () {
            var vp = self._viewport;
            var atStart = vp.scrollLeft <= 1;
            var atEnd = vp.scrollLeft + vp.clientWidth >= vp.scrollWidth - 1;
            self.classList.toggle('at-start', atStart);
            self.classList.toggle('at-end', atEnd);
         };

         this._viewport.addEventListener('scroll', debounce(updateArrows, 50), { passive: true });
         window.addEventListener('resize', debounce(updateArrows, 100));
         updateArrows();
         
         /* ── POP-875, sub-category rail on mobile only ──
            Scoped to the .csm-wrapper--mobile-spacing variant and to the
            767px breakpoint where the CSS switches to the swipeable story
            layout, so the control rail and every desktop rail behave
            exactly as before.
            The rail always loads scrolled to the start, so on a PLP deep in
            the list the tile for the collection being viewed sits off-screen
            and its highlight is invisible. Centre it in the rail instead.
            Scrolls the rail only — never the page — so it cannot fight
            Shopify's scroll restoration. */
            if (!this.classList.contains('csm-wrapper--mobile-spacing')) return;

            /* Scroll offset that puts the current tile in the middle of the
               rail, or null when there is nothing to do. */
            var centeredScrollTarget = function () {
               var vp = self._viewport;
               var active = self.querySelector('.csm-item--active');
               if (!active) return null;
   
               var maxScroll = vp.scrollWidth - vp.clientWidth;
               if (maxScroll <= 1) return null;
   
               var vpRect = vp.getBoundingClientRect();
               var activeRect = active.getBoundingClientRect();
               var delta = activeRect.left - vpRect.left - (vp.clientWidth - active.offsetWidth) / 2;
               return Math.max(0, Math.min(vp.scrollLeft + delta, maxScroll));
            };
   
            /* Same hold-and-retry shape as the POP-439 A/B test: keep nudging
               for two seconds so late layout shifts (webfont swap, lazy tile
               images) cannot leave the rail parked in the wrong place, and
               hand control straight back on the first gesture. */
            var centerActiveOnLoad = function () {
               var vp = self._viewport;
               var HOLD_MS = 2000;
               var STEP_MS = 100;
               var gestures = ['wheel', 'touchstart', 'pointerdown', 'keydown'];
               var userInteracted = false;
               var elapsed = 0;
               var timer = 0;
   
               var onGesture = function () {
                  userInteracted = true;
               };
   
               var cleanup = function () {
                  clearTimeout(timer);
                  gestures.forEach(function (type) {
                     vp.removeEventListener(type, onGesture);
                  });
               };
   
               var step = function () {
                  if (userInteracted || !window.matchMedia('(max-width: 767px)').matches) {
                     cleanup();
                     return;
                  }
   
                  var target = centeredScrollTarget();
                  if (target !== null && Math.abs(vp.scrollLeft - target) > 2) {
                     vp.scrollLeft = target;
                     updateArrows();
                  }
   
                  elapsed += STEP_MS;
                  if (elapsed < HOLD_MS) {
                     timer = setTimeout(step, STEP_MS);
                  } else {
                     cleanup();
                  }
               };
   
               gestures.forEach(function (type) {
                  vp.addEventListener(type, onGesture, { passive: true, once: true });
               });
               step();
            };
   
            centerActiveOnLoad();
      }
   });
})();
